import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default class EditBreakDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.break
            ? this.props.isEvent
              ? languages.schedule.editEvent
              : languages.schedule.editBreak
            : this.props.isEvent
            ? languages.schedule.addEvent
            : languages.schedule.addBreak}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              autoFocus
              label={languages.general.name}
              value={this.props.name}
              name="name"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
            />
            <br />
            <br />
            <FormControl
              aria-describedby="weight-helper-text"
              style={{ width: "100%" }}
            >
              <InputLabel htmlFor="break-duration">
                {languages.schedule.duration}
              </InputLabel>
              <Input
                id="break-duration"
                type="number"
                name="duration"
                placeholder="20"
                value={this.props.duration}
                onChange={this.props.handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    {languages.schedule.minutes}
                  </InputAdornment>
                }
              />
            </FormControl>
            {this.props.isEvent && (
              <Autocomplete
                style={{ marginTop: 20 }}
                groupBy={option => option.labelDivision || ""}
                size="small"
                multiple
                disableCloseOnSelect
                options={this.props.options}
                getOptionLabel={option => option.label}
                // getOptionSelected={option => {
                //   return props.value.find(v => option.id === v.id) ? true : false;
                // }}
                onChange={(e, newValue) => {
                  this.props.handleSelectChange(e, newValue);
                }}
                value={this.props.selectedValue}
                renderOption={(option, { selected }) => {
                  let isSelected = selected;
                  if (option.value === "all") {
                    isSelected = this.props.selectedValue.find(
                      v => v.value === "all"
                    )
                      ? true
                      : false;
                  }
                  let label = option.label;
                  if (option.value === "all") {
                    label = <b>{option.label}</b>;
                  }
                  return (
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={isSelected}
                      />
                      {label}
                    </React.Fragment>
                  );
                }}
                renderInput={params => {
                  return (
                    <TextField
                      {...params}
                      variant="standard"
                      // placeholder={languages.schedule.allPoulesBrackets}
                      label={languages.tournament.teams}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  );
                }}
                clearText=""
                closeText=""
                openText=""
                noOptionsText=""
              />
            )}
          </DialogContent>
          <DialogActions>
            {this.props.break && (
              <Button onClick={this.props.handleDelete} color="secondary">
                {languages.general.delete}
              </Button>
            )}
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
              disabled={this.props.isEvent && this.props.name.length === 0}
            >
              {this.props.break
                ? languages.general.save
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
